module.exports = __webpack_public_path__ + "static/img/wechat.072f51f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat.jpeg
// module id = y336
// module chunks = 1